/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Export_FileInputs */



/**
* | output |
* | --- |
* | "Open the export menu" |
*
* @param {Shortcut_Keys_Desc_Export_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_export_file = /** @type {((inputs?: Shortcut_Keys_Desc_Export_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Export_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir le menu d'export")
	if (locale === "de") return /** @type {LocalizedString} */ ("Öffnen Sie das Exportmenü")
	if (locale === "it") return /** @type {LocalizedString} */ ("Apri il menu di esportazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Откройте меню экспорта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abrir el menú de exportación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("打开导出菜单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートメニューを開く")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात मेनू खोलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Abra o menu de exportação")
	return /** @type {LocalizedString} */ ("Open the export menu")
});